import React from "react";
import { createSkipLink } from "../../utils/accessibility";

/**
 * Skip Navigation Component
 *
 * Provides keyboard users with quick navigation to main content areas
 * Hidden visually but accessible to screen readers and keyboard navigation
 */
const SkipNavigation = () => {
  React.useEffect(() => {
    // Ensure main content area has proper ID
    const mainContent = document.querySelector("main");
    if (mainContent && !mainContent.id) {
      mainContent.id = "main-content";
    }
  }, []);

  return (
    <div className="skip-navigation">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-white dark:focus:bg-gray-800 focus:text-primary-600 dark:focus:text-primary-400 focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
        onClick={(e) => {
          e.preventDefault();
          const target = document.getElementById("main-content");
          if (target) {
            target.tabIndex = -1;
            target.focus();
            target.scrollIntoView({ behavior: "smooth" });
          }
        }}
      >
        Skip to main content
      </a>

      <a
        href="#navigation"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-48 focus:z-50 focus:px-4 focus:py-2 focus:bg-white dark:focus:bg-gray-800 focus:text-primary-600 dark:focus:text-primary-400 focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
        onClick={(e) => {
          e.preventDefault();
          const target = document.querySelector('nav[role="navigation"]');
          if (target) {
            target.tabIndex = -1;
            target.focus();
            target.scrollIntoView({ behavior: "smooth" });
          }
        }}
      >
        Skip to navigation
      </a>
    </div>
  );
};

export default SkipNavigation;
